export default {
  // 共通
  QUESTIONNAIRE_REQUEST_TITLE: "アンケートのお願い",
  QUESTIONNAIRE_REQUEST_DESCRIPTION:
    "サービスの品質改善を目的としてアンケート調査を実施することにいたしました。 今後のサービス改善のため、ご協力いただけますと幸いです。",
  QUESTIONNAIRE_TEXT_AREA_PLACEHOLDER: "その他を選択された方はこちらに詳細を記入ください。",
  SEND_QUESTIONNAIRE: "アンケートを送信",
};
